import React from 'react';

// Dont blur input when there's a mouseclick on the search suggestions
const preventDefault = evt => {
    evt.preventDefault();
};

// https://github.com/facebook/react/issues/3386#issuecomment-291152357
const HighlightWord = ({ text, query = '', className = '' }) => {
    if (!text) { return; }
    if (!query) {
        return (<span className={className}>{text}</span>);
    }
    return (
        <span className={`font-weight-bold ${className}`}>
            {text.split(query)
                .reduce((prev, current, i) => {
                    if (!i) {
                        return [current];
                    }
                    return prev.concat(<span className={`font-weight-normal`} key={query + current}>{query}</span>, current);
                }, [])
            }
        </span>
    );
};


export const PreviousSearchesListItem = ({
    item,
    changeSearchTerm,
    searchTerm,
    isSelected,
    selectedCategoryId
}) => {

    return (
        <a
            data-suggestion
            className={`list-group-item list-group-item-action slim-header__search-suggestion ${isSelected ? 'slim-header__search-suggestion--active' : ''}`}
            data-previous-suggestion={item.key}
            onClick={changeSearchTerm}
            onMouseDown={preventDefault}
            data-ga-category="Search Box"
            data-ga-action="Navigation"
            data-ga-label="recent suggestion"
            href={`/search?q=${item.key}&categoryId=${selectedCategoryId ? selectedCategoryId : 0}`}>
            <HighlightWord
                className="clock--before ss-fix--before slim-header__search-suggestion-label"
                query={searchTerm}
                text={item.key} />
        </a>
    )
};

export const SearchesSuggestionsListItem = ({
    item,
    changeSearchTerm,
    searchTerm,
    isSelected,
    selectedCategoryId
}) => {

    const categoryId = item.category ? item.category.id :
        (selectedCategoryId ? selectedCategoryId : 0);

    return (
        <a
            data-suggestion
            className={`list-group-item list-group-item-action slim-header__search-suggestion ${isSelected ? 'slim-header__search-suggestion--active' : ''}`}
            data-search-suggestion={item.text}
            onClick={changeSearchTerm}
            onMouseDown={preventDefault}
            data-ga-category="Search Box"
            data-ga-action="Navigation"
            data-ga-label={`${item.category ? 'category suggestion' : 'normal suggestion' }`}
            href={`/search?q=${item.text}&categoryId=${categoryId}`}>
            <HighlightWord
                query={searchTerm}
                text={item.text} />
            <i> {item.category ? `inom ${item.category.name}` : ''}</i>
        </a>
    );
}

export const ShopsSuggestionsListItem = ({
    item,
    changeSearchTerm,
    searchTerm,
    isSelected
}) =>
    <a
        data-suggestion
        className={`list-group-item list-group-item-action slim-header__search-suggestion ${isSelected ? 'slim-header__search-suggestion--active' : ''}`}
        data-shop-suggestion={item.name}
        onClick={changeSearchTerm}
        onMouseDown={preventDefault}
        data-ga-category="Search Box"
        data-ga-action="Navigation"
        data-ga-label="shop suggestion"
        href={`/profile/items/${item.memberId}/${item.urlName}`}>
        <em className="slim-header__search-suggestion-shop-pill">Butik</em>
        <HighlightWord
            query={searchTerm}
            text={item.name} />
    </a>;

export const AdvancedSearchListItem = ({
    isSelected
}) => {
    return (
        <a href="/search/detailed"
            data-suggestion
            data-advanced-search
            data-ga-category="Header"
            data-ga-action="Navigation"
            data-ga-label="Advanced search"
            className={`list-group-item list-group-item-action slim-header__search-advanced underline slim-header__search-suggestion ${isSelected ? 'slim-header__search-suggestion--active' : ''}`}
            onMouseDown={preventDefault} >
            <span className="slim-header__search-advanced-icon icon icon--filter float-right ss-fix--before" />
            <span className="slim-header__search-advanced-label underline">Gå till Avancerad sökning</span>
        </a>
    );
}


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/search-suggestion/suggestion-list-items.jsx